import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'assignBox'
})
export class AssignBoxPipe implements PipeTransform {

  transform(groups: any, searchParam: string): any {

    if (searchParam == null || searchParam.length < 1) {
      return groups
    }

    let filteredGroups = [];
    let rawData = JSON.parse(JSON.stringify(groups));
    let searchTerm = searchParam.toLowerCase();

    for (let i = 0; i < rawData.length; i++) {
      if(rawData[i].GroupName.toLowerCase().indexOf(searchTerm) > -1){
        filteredGroups.push(rawData[i]);
      }
    }

    return filteredGroups;
  }
}